module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "zone content-part",
    style: ({
      width: '1600px',
      margin: '0 auto',
      padding: '0',
      overflow: 'visible'
    })
  }, [_c('div', {
    staticClass: "heatmap"
  }, [_c('h1', [_vm._v(_vm._s(_vm.params.pagename))]), _c('p', [_vm._v("(" + _vm._s(_vm.params.url) + ")")]), _c('timeSpan', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timespan),
      expression: "timespan"
    }],
    attrs: {
      "filters": "yesterday"
    },
    domProps: {
      "value": (_vm.timespan)
    },
    on: {
      "input": function($event) {
        _vm.timespan = $event
      }
    }
  }), _c('div', [_vm._v("访问地域："), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterParams.region),
      expression: "filterParams.region"
    }],
    on: {
      "change": function($event) {
        _vm.filterParams.region = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.regionOptions), function(item) {
    return _c('option', {
      key: item,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  })), _vm._v("访问来源："), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterParams.source),
      expression: "filterParams.source"
    }],
    on: {
      "change": function($event) {
        _vm.filterParams.source = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, _vm._l((_vm.sourceOptions), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.value))])
  })), _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "key"
  }, [_vm._v("PV: ")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.summary.pv))])]), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "key"
  }, [_vm._v("UV: ")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.summary.uv))])]), _c('div', {
    staticClass: "line"
  }, [_c('span', {
    staticClass: "key"
  }, [_vm._v("点击量: ")]), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.summary.click))])])]), _c('div', {
    staticClass: "color-line"
  }, [_vm._v("热度："), _vm._l((_vm.colorBlock), function(colorUnit, index) {
    return _c('div', {
      key: colorUnit.color,
      staticClass: "color-unit"
    }, [_c('div', {
      staticClass: "color-block",
      style: ({
        background: colorUnit.showColor
      }),
      on: {
        "click": function($event) {
          _vm.filterByColor(index)
        }
      }
    })])
  })], 2)])], 1), _c('hr'), _c('div', {
    ref: "hmCon",
    staticClass: "hm-container",
    style: ({
      width: '1600px',
      margin: '10px auto',
      height: _vm.maxH + 'px'
    })
  }, [_c('iframe', {
    attrs: {
      "name": "heatiframe",
      "width": "100%",
      "height": "100%",
      "frameborder": "0",
      "src": _vm.iframeSrc
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a3b5182", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7a3b5182!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/heatmap.vue
// module id = 775
// module chunks = 0